import React from 'react'
import { maxDailyScore } from '../utils/constants'
import frame0 from '../assets/flower/0.png'
import frame1 from '../assets/flower/1.png'
import frame2 from '../assets/flower/2.png'
import frame3 from '../assets/flower/3.png'
import frame4 from '../assets/flower/4.png'
import frame5 from '../assets/flower/5.png'
import frame6 from '../assets/flower/6.png'
import frame7 from '../assets/flower/7.png'
import frame8 from '../assets/flower/8.png'
import frame9 from '../assets/flower/9.png'
import _ from 'lodash'

const frames = [
  frame0,
  frame1,
  frame2,
  frame3,
  frame4,
  frame5,
  frame6,
  frame7,
  frame8,
  frame9,
]

const styles = {
  img: {
    width: '40px',
  },
}

const Flower = ({ score }) => {
  const index = _.floor((score / maxDailyScore) * (frames.length - 1))
  const frame = frames[index]
  return (
    <div>
      <img
        alt=""
        src={frame}
        style={styles.img}
        onClick={() =>
          alert('The more points you put in, the bigger the flower grows! :)')
        }
      />
    </div>
  )
}

export default Flower
